import * as Yup from "yup";
import { reverseShape } from "Components/shared/helpers/reverse-shape";
import {
  decimal,
  validBoolean,
  validString,
} from "Components/shared/helpers/validations";

const goodsFields = Yup.object().shape({
  typeOfGood: validString.required(),
  goodsValue: decimal.required(),
  trackingNumber: validString.optional(),
});

const parcelFields = Yup.object().shape({
  length: decimal.required(),
  width: decimal.required(),
  height: decimal.required(),
  weight: decimal.required(),
  remarks: validString.optional(),
  goods: Yup.array().of(goodsFields).min(1),
});

const parcels = Yup.array().of(parcelFields).min(1);

export const ParcelInfoSchema = Yup.object().shape(
  reverseShape({
    hasInsurance: validBoolean.optional(),
    // looseOrders: validBoolean.optional(),
    parcels: parcels.required(),
  }),
);

export default ParcelInfoSchema;
